"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.StopwatchStore = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _msToTime = require("../../../../common/msToTime");

var _StopwatchTimer = require("./StopwatchTimer");

var _UniqueIdGenerator = require("../../../../common/UniqueIdGenerator");

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

var StopwatchStore = (_class = (_temp =
/*#__PURE__*/
function () {
  function StopwatchStore() {
    (0, _initializerDefineProperty2.default)(this, "isRunning", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "timer", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "startTime", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "fastestLap", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "slowestLap", _descriptor5, this);
    (0, _initializerDefineProperty2.default)(this, "averageLap", _descriptor6, this);
    (0, _initializerDefineProperty2.default)(this, "split", _descriptor7, this);
    this.offsetTime = void 0;
    this.initTimes();
  }

  var _proto = StopwatchStore.prototype;

  _proto.initTimes = function initTimes() {
    this.fastestLap = 0;
    this.slowestLap = 0;
    this.averageLap = 0;
  };

  _proto.measure = function measure() {
    var _this = this;

    if (!this.isRunning) {
      return;
    }

    var now = Date.now();
    this.timer.milliseconds += now - this.offsetTime;
    this.offsetTime = now;
    setTimeout(function () {
      return _this.measure();
    }, 10);
  };

  _proto.startTimer = function startTimer() {
    if (this.isRunning) {
      return;
    }

    this.isRunning = true;
    this.startTime = Date.now();
    this.offsetTime = this.startTime;
    this.measure();
  };

  _proto.lapTimer = function lapTimer() {
    var newTimer = new _StopwatchTimer.StopwatchTimer(this.timer.totalMilliSeconds, this.splitTime);
    this.split.push(newTimer);

    if (this.fastestLap === 0 || newTimer.totalMilliSeconds < this.fastestLap) {
      this.fastestLap = newTimer.totalMilliSeconds;
    }

    if (newTimer.totalMilliSeconds > this.slowestLap) {
      this.slowestLap = newTimer.totalMilliSeconds;
    }

    this.averageLap = this.splitTime / this.length;
  };

  _proto.stopTimer = function stopTimer() {
    this.timer.saveTime();
    this.isRunning = false;
  };

  _proto.resetTimer = function resetTimer() {
    this.split = [];
    this.initTimes();
    this.timer.reset();
  };

  (0, _createClass2.default)(StopwatchStore, [{
    key: "mainDisplay",
    get: function get() {
      return this.timer.displayLap;
    }
  }, {
    key: "length",
    get: function get() {
      return this.split.length;
    }
  }, {
    key: "splitTime",
    get: function get() {
      return this.split.map(function (el) {
        return el.totalMilliSeconds;
      }).reduce(function (x, y) {
        return x + y;
      }, 0);
    }
  }, {
    key: "splitData",
    get: function get() {
      var data = [];

      for (var i = 0; i < this.split.length; i++) {
        data.push({
          id: _UniqueIdGenerator.UniqueIdGenerator.generate(),
          lapNumber: "" + (i + 1),
          split: this.split[i]
        });
      }

      return data.reverse();
    }
  }, {
    key: "displayFastestLap",
    get: function get() {
      return (0, _msToTime.msToTime)(this.fastestLap);
    }
  }, {
    key: "displaySlowestLap",
    get: function get() {
      return (0, _msToTime.msToTime)(this.slowestLap);
    }
  }, {
    key: "displayAverageLap",
    get: function get() {
      return (0, _msToTime.msToTime)(this.averageLap);
    }
  }]);
  return StopwatchStore;
}(), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isRunning", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "timer", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return new _StopwatchTimer.StopwatchTimer();
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "startTime", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fastestLap", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "slowestLap", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "averageLap", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "split", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "mainDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mainDisplay"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "measure", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "measure"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "startTimer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "startTimer"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "length", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "length"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "splitTime", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "splitTime"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "lapTimer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "lapTimer"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "splitData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "splitData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "stopTimer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "stopTimer"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetTimer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetTimer"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayFastestLap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayFastestLap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displaySlowestLap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displaySlowestLap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayAverageLap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayAverageLap"), _class.prototype)), _class);
exports.StopwatchStore = StopwatchStore;